import { axiosInstance } from "../../../utils";

const actions = {
    CREATE_OR_UPDATE_BRAND_REQUESTED: 'CREATE_OR_UPDATE_BRAND_REQUESTED',
    CREATE_OR_UPDATE_BRAND_SUCCEEDED: 'CREATE_OR_UPDATE_BRAND_SUCCEEDED',
    CREATE_OR_UPDATE_BRAND_FAILED: 'CREATE_OR_UPDATE_BRAND_FAILED',

    addOrUpdateBrand: (data = undefined) => {
        return {
            type: actions.CREATE_OR_UPDATE_BRAND_REQUESTED,
            payload: data
        }},

    createOrUpdateBrand: async (data = undefined) => {
        let url = `brands/create`;
        let bodyFormData = new FormData();

        if (data.name) bodyFormData.set('name', data.name );
        if (data.name_ar) bodyFormData.set('name_ar', data.name_ar );
        if (data.parent_ids) bodyFormData.set('parent_ids', JSON.stringify(data.parent_ids ));
        if (data.thumbnail) bodyFormData.append('thumbnail', data.thumbnail );

        if(data._id) {
            url = `brands/` + data._id
            try {
                const brand = await axiosInstance.put(url, bodyFormData);
                return brand.data;
            } catch (error) {
                throw error;
            }
        } else {
            try {
                const brand = await axiosInstance.post(url, bodyFormData);
                return brand.data;
            } catch (error) {
                throw error;
            }
        }
    }
};

export default actions;
